export default __webpack_public_path__ + "static/media/ticketing.9706176c.svg";